import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// Icons & Images
import Morale from "assets/icons/improve_morale.svg";
import ArrowChart from "assets/icons/arr-chart.svg";
import Diamond from "assets/icons/diamond.svg";
import Ammuni from "assets/icons/ammuni.svg";
import Military from "assets/icons/military.svg";
import MODLoader from "assets/images/mod-loader.gif";

import GreenArrow from "assets/icons/greenright.svg";
import AmberArrow from "assets/icons/yellowright.svg";
import RedArrow from "assets/icons/redright.svg";
import LinkedInitiative from "assets/icons/linked.svg";
import ContractIcon from "assets/icons/contract-icon.svg";
import ApprovedIcon from "assets/icons/approved-icon.svg";
import SpentIcon from "assets/icons/spent-icon.svg";

// Scss
import "./NewStrategicObjectives.scss";

// Variables & Constants
const apiUri = "https://arrowmod.dig-x.co.in";

function StrategicObjectives() {
  let [strategicObjectives, setStrategicObjectives] = useState([]);
  let [isLoader, setIsLoader] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoader(true);
      const response = await axios.get(`${apiUri}/api/StrategicObjectives`);
      setStrategicObjectives(response.data);
      setIsLoader(false);
    }
    fetchData();
  }, []);

  const strategicTiles = StrategicTile(strategicObjectives);

  return (
    <>
      {isLoader && (
        <div className="loader-container">
          <img src={MODLoader} alt="#" />
        </div>
      )}
      {
        <div className="objective-dashboard-cover">
          {strategicObjectives.length > 0 ? (
            strategicTiles
          ) : (
            <div>No Data Found</div>
          )}
        </div>
      }
    </>
  );
}
function StrategicTile(strategicObjectives) {
  let navgiate = useNavigate();
  let listOfImages = [Morale, ArrowChart, Diamond, Ammuni, Military];
  function redirectPage(to, data) {
    navgiate(to, { state: data });
  }

  function convertValues(number) {
    number = number.toString().replace(/,/g, "");
    var formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
    });

    if (number < 1000000 && number > 1000) {
      // Anything less than a million

      return formatter.format(number) + " K";
    } else if (number < 1000000000 && number > 1000000) {
      // Anything less than a billion

      number = number / 1000000;

      return formatter.format(number) + " M";
    } else if (number > 1000000000) {
      // At least a billion

      number = number / 1000000000;

      return formatter.format(number) + " B";
    } else {
      return formatter.format(number);
    }
  }
  const strategicTiles = strategicObjectives.map((item, index) => {
    return (
        <div
          key={index}
          className="multiple-dasboards"
          onClick={() => {
            redirectPage(`/impacts-tracking-dashboard`, {
              selected: item.StrategicObjective,
            });
          }}
        >
          <div className="top-dashboard-title">
            <div className="dashboard-count">
              <span className="number">{`${index + 1}`}</span>
            </div>
            <div className="dash-img">
              <img src={listOfImages[index]} alt="dash-img" />{" "}
            </div>
            <div className="dash-title">
              <span>{item.StrategicObjective}</span>
            </div>
          </div>
          {/* dash status */}
          <div className="dash-status">
            <span>IMPACT STATUS</span>
            {item.Impacts.map((impact, index) => {
              return (
                <div className="impact-status-details" key={index}>
                  <span className="status-title">{impact.Title}</span>
                  <div className="impact-status">
                    <div
                      className={`
                  impact-progress
                  ${
                    impact.Variance >= -5
                      ? "green"
                      : impact.Variance < -5 && impact.Variance >= -10
                      ? "amber"
                      : "red"
                  }
                `}
                      onClick={() => {
                        redirectPage(`/impacts-tracking`, {
                          selected: impact.ID,
                          title: impact.Title,
                          SO: item.StrategicObjective,
                        });
                      }}
                    ></div>
                    <img
                      src={`
                            ${
                              impact.Variance >= -5
                                ? GreenArrow
                                : impact.Variance < -5 && impact.Variance >= -10
                                ? AmberArrow
                                : RedArrow
                            }
                          `}
                      alt="green-triangle"
                      className={
                        impact.Variance === 0
                          ? ""
                          : impact.Variance > 0
                          ? "rotate-up"
                          : "rotate-down"
                      }
                    />
                  </div>

                  <div className="target-current-measures">
                    <div
                      className={`
                          target
                          ${
                            impact.Variance >= -5
                              ? "light-green"
                              : impact.Variance < -5 && impact.Variance >= -10
                              ? "light-amber"
                              : "light-red"
                          }
                  `}
                    >
                      <span className="target-title">Target Measure</span>
                      <span
                        className={`
                          percent
                          ${
                            impact.Variance >= -5
                              ? "green-text"
                              : impact.Variance < -5 && impact.Variance >= -10
                              ? "amber-text"
                              : "red-text"
                          }
                  `}
                      >
                        {impact.TargetMeasurement}%
                      </span>
                    </div>
                    <div
                      className={`
                          current
                          ${
                            impact.Variance >= -5
                              ? "light-green"
                              : impact.Variance < -5 && impact.Variance >= -10
                              ? "light-amber"
                              : "light-red"
                          }
                  `}
                    >
                      <span className="target-title">Current Measure</span>
                      <span
                        className={`
                          percent
                          ${
                            impact.Variance >= -5
                              ? "green-text"
                              : impact.Variance < -5 && impact.Variance >= -10
                              ? "amber-text"
                              : "red-text"
                          }
                  `}
                      >
                        {impact.CurrentMeasurement}%
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* initiatives  */}
          <div className="initiatives-cover">
            <div className="linked-initiatives">
              <div className="">
                <img src={LinkedInitiative} alt="linked initiative" />
              </div>
              <div className="tag-name">
                <span>Linked Initiatives</span>
              </div>
              <div className="initiative-number">
                <span>
                  {parseInt(item.OnTrackProjects) +
                    parseInt(item.ModerateDelayProjects) +
                    parseInt(item.SignificantDelayProjects) +
                    parseInt(item.NotStartedProjects)}
                </span>
              </div>

              <div className="initiate-tabs">
                <div className="tabs-detail on-track">
                  <h6>On Track</h6>
                  <div className="track-count track-green">
                    <span>{parseInt(item.OnTrackProjects)}</span>
                  </div>
                </div>

                <div className="tabs-detail moderate-delay">
                  <h6>Moderate Delay</h6>
                  <div className="track-count track-amber">
                    <span>{parseInt(item.ModerateDelayProjects)}</span>
                  </div>
                </div>

                <div className="tabs-detail significant-delay">
                  <h6>Significant Delay</h6>
                  <div className="track-count track-red">
                    <span>{parseInt(item.SignificantDelayProjects)}</span>
                  </div>
                </div>
                <div className="tabs-detail not-started">
                  <h6>Not Started</h6>
                  <div className="track-count track-not-started">
                    <span>{parseInt(item.NotStartedProjects)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* budget */}
          <div className="budget-cover">
            <div className="budget-details">
              <div className="budget-title">
                <span>BUDGET</span>
              </div>
              <div className="budget-tiles-cover">
                <div className="budget-tile">
                  <div className="budget-icon">
                    <img src={ApprovedIcon} alt="approvec-icon" />
                  </div>
                  <div className="budget-value">
                    <span className="b-tag">Approved Budget</span>
                    <span className="b-number">
                      {convertValues(item.ApprovedBudget)}
                    </span>
                  </div>
                </div>

                <div className="budget-tile">
                  <div className="budget-icon">
                    <img src={ContractIcon} alt="contract-icon" />
                  </div>
                  <div className="budget-value">
                    <span className="b-tag">Contracted value</span>
                    <span className="b-number">
                      {convertValues(item.ContractedValue)}
                    </span>
                  </div>
                </div>

                <div className="budget-tile">
                  <div className="budget-icon">
                    <img src={SpentIcon} alt="spent-icon" />
                  </div>
                  <div className="budget-value">
                    <span className="b-tag">Spent Value</span>
                    <span className="b-number">
                      {convertValues(item.SpentValue)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  });
  return strategicTiles;
}

export default StrategicObjectives;
